(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ImageFilter", [], factory);
	else if(typeof exports === 'object')
		exports["ImageFilter"] = factory();
	else
		root["ImageFilter"] = factory();
})(this, () => {
return 